import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-058cf889"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "countdown-container"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, ":", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, ":", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1), _createElementVNode("span", null, _toDisplayString(_ctx.data.hour), 1), _hoisted_3, _createElementVNode("span", null, _toDisplayString(_ctx.data.minute), 1), _hoisted_4, _createElementVNode("span", null, _toDisplayString(_ctx.data.second), 1)]);
}